import {
  baseUniDriverFactory,
  findByHook,
} from '../utils/test-utils/unidriver';
import type { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { dataHooks } from './TopBanner.constants';

export const topBannerDriverFactory = (base: UniDriver) => {
  const dismissButton = findByHook(base, dataHooks.dismissButton);
  const content = findByHook(base, dataHooks.content);

  return {
    ...baseUniDriverFactory(base),
    /** Gets the content of top banner. */
    getContent: () => content.text(),

    /** Checks if the dismiss button exists. */
    hasDismissButton: () => dismissButton.exists(),

    /** Clicks the dismiss button */
    clickDismissButton: () => dismissButton.click(),
  };
};

export type TopBannerUniDriver = ReturnType<typeof topBannerDriverFactory>;
